export const constants = {
    backendAddress: "https://piersonmfg.com",
    // backendAddress: "http://172.20.10.4:8000",
    linkAddress: "http://localhost:8001",
};
